import React from 'react';
import HomeView from './homepage/HomeView';
import Layout from './Layout';

export default () => (
  <Layout header={false}>
    <HomeView />
  </Layout>
);
